<template>
  <div id="app" :class="{ statusNotAllow: productStatus !== 'S' }">
    <div class="warnWrapNotify" v-if="productStatus !== 'S'">{{ mes }}</div>
    <router-view></router-view>
  </div>
</template>

<script>
  import { getThirdUserInfo } from '@/api/user'
  import { homepageresources } from '@/api/company-appointment'
  import { SetGetAuthInfo } from './util/auth'
  import { register } from '@/util/config'

  export default {
    name: 'app',
    components: {
      // FroceBind
    },
    data() {
      return {
        productStatus: 'S',
        mes: ''
        // isForce: false
      }
    },
    async created() {},
    async mounted() {
      await this.autoFontSize()
      await this.appsensors()

      const res = await homepageresources()
      console.log('B备案中S售卖D下架T测试售卖', res.goodsExt.SALE_STATUS)
      this.productStatus =
        process.env.VUE_APP_BUILD_TARGET === 'prod' &&
        process.env.VUE_APP_SALE_STATUS !== 'B'
          ? res.goodsExt.SALE_STATUS
          : process.env.VUE_APP_SALE_STATUS
      this.$store.commit('SET_PRODUCT_STATUS', this.productStatus)
      console.log('store打印', this.$store.state.productStatus)
      if (
        this.productStatus == 'B' ||
        this.productStatus == 'D' ||
        this.productStatus == 'T'
      ) {
        this.mes = ''
        switch (this.productStatus) {
          case 'B':
            this.mes = '产品备案中，敬请期待！'
            break
          case 'D':
            this.mes = '参保时间已过，感谢您的关注！'
            break
          case 'T':
            this.mes = '测试售卖'
            break
        }
      }
    },
    updated() {},
    methods: {
      // 神策埋点
      async appsensors() {
        let res = 0
        if (SetGetAuthInfo.getInfo().mobilePhone) {
          res = await getThirdUserInfo({
            mobilePhone: SetGetAuthInfo.getInfo().mobilePhone
          })
        }
        this.$sensors.init({
          server_url: register,
          is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
          use_client_time: true,
          send_type: 'ajax',
          heatmap: {
            //是否采集div标签
            collect_tags: {
              div: {
                max_level: 3
              },
              img: true
            },
            //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以	设置 	'not_collect' 表示关闭。
            clickmap: 'default',
            //是否开启触达注意力图，not_collect 表示关闭，不会自动采集 	$WebStay 事件，可以设置 'default' 表示开启。
            scroll_notice_map: 'not_collect',
            collect_input: 'true'
          }
        })
        // 设置公共属性
        this.$sensors.registerPage({
          // 手机系统或平台
          platformCode: this.$store.state.deviceInfo.env,
          // 业务线
          businessCode: 'HMB',
          // 编码
          appCode: process.env.VUE_APP_BAOSICODE,
          userId: res
        })
        // 初始化时，如果想把埋点的数据放入缓冲中， 通过如下方式来处理
        this.$sensors.quick('isReady', () => {
          localStorage.setItem(
            'anonymous_id',
            this.$sensors.quick('getAnonymousID')
          )
          localStorage.setItem(
            'distinct_id',
            this.$sensors.getPresetProperties()._distinct_id
          )
        })
      },
      async autoFontSize() {
        console.log('autoFontSize', window.WeixinJSBridge)
        let WeixinJSBridge = window.WeixinJSBridge
        if (
          typeof WeixinJSBridge === 'object' &&
          typeof WeixinJSBridge.invoke === 'function'
        ) {
          handleFontSize()
        } else {
          // console.log('document.addEventListener', document.addEventListener)
          if (document.addEventListener) {
            document.addEventListener(
              'WeixinJSBridgeReady',
              handleFontSize,
              false
            )
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', handleFontSize)
            document.attachEvent('onWeixinJSBridgeReady', handleFontSize)
          }
        }
        function handleFontSize() {
          // console.log('调用了重新设置字体的函数', window.WeixinJSBridge)
          let WeixinJSBridge = window.WeixinJSBridge
          // 设置网页字体为默认大小
          WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 })
          // 重写设置网页字体大小的事件
          WeixinJSBridge.on('menu:setfont', function() {
            WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 })
          })
        }
      }
    }
  }
</script>

<style lang="scss">
  /* @import './styles/app.scss';*/
  .statusNotAllow {
    padding-top: 39px;
  }
  .statusNotAllow .van-sticky--fixed {
    top: 39px !important;
  }
  .warnWrapNotify {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 40px;
    line-height: 40px;
    text-align: center;
    z-index: 999;
    background: yellow;
    color: red;
    font-weight: bold;
  }
</style>
